import React, { useRef } from 'react';
import ControlSwitch from '@/Shared/Form/ControlSwitch';
import { useFormContext, useWatch } from 'react-hook-form';
import Input from '@/Shared/Form/Input';

const RequiredByContract = () => {
  const { control, formState: { errors } } = useFormContext();
  const isSelected = useWatch({ name: 'requiredByContract', control });

  return (
    <React.Fragment>
      <div className="mb-3">
        <ControlSwitch
          labelOff='No'
          labelOn='Yes'
          name='requiredByContract'
        />
      </div>
      {isSelected && (
        <Input
          isRequired
          labelText='Please list the data that is required for the contract and explain the purpose'
          name='requiredByContractValue'
          type='text'
          placeholder='e.g., "Name and email are required to register an account and send login credentials'
        />
      )}
    </React.Fragment>
  );
};

export default RequiredByContract;